var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    viewBox: "0 0 14 9",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_chevron_down_svg__a",
    d: "M13.955 5.288a1.004 1.004 0 0 1 1.41.003l.085.095a.994.994 0 0 1-.08 1.316l-4.976 4.974 4.975 4.975c.352.353.384.924.08 1.317l-.083.094a.995.995 0 0 1-1.411.004l-5.663-5.664a1 1 0 0 1-.287-.656.99.99 0 0 1 .287-.795Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_chevron_down_svg__a",
    fill: "var(--secondary-color)",
    fillRule: "evenodd",
    transform: "scale(1 -1)rotate(90 17.509 1)"
  })));
};
export default SvgIconChevronDown;